import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import MaualContent from './MaualContent';
import fnc from '../mymod/commFunction';
import './MaualEmbedPage.scss';

const sendRequest = (url, data) => new Promise((resolve) => {
    fnc.sendAxios(url, data, (response) => {
        resolve(response);
    });
});

const MaualEmbedPage = () => {
    const { unit2Code } = useParams();
    const [selectedContent, setSelectedContent] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        let cancelled = false;

        const loadContent = async () => {
            if (!unit2Code) {
                setSelectedContent(null);
                setErrorMessage('게시글 코드가 없습니다.');
                setIsLoading(false);
                return;
            }

            setIsLoading(true);
            setErrorMessage('');

            try {
                const [detailRes, contentRes] = await Promise.all([
                    sendRequest('/boardRoutes/select_board_unit2_detail', { unit2_code: unit2Code }),
                    sendRequest('/boardRoutes/select_board_content', { unit2_code: unit2Code })
                ]);

                if (cancelled) {
                    return;
                }

                const detail = Array.isArray(detailRes) ? detailRes[0] : null;
                const content = Array.isArray(contentRes) ? contentRes[0] : null;

                if (!detail) {
                    setSelectedContent(null);
                    setErrorMessage('게시글을 찾을 수 없습니다.');
                    setIsLoading(false);
                    return;
                }

                const nextContent = {
                    unit2_code: detail.unit2_code || unit2Code,
                    unit2_name: detail.unit2_name || unit2Code,
                    pCode: detail.pCode || '',
                    content: content?.content || ''
                };

                setSelectedContent(nextContent);
                document.title = nextContent.unit2_name || '매뉴얼';
            } catch (error) {
                if (!cancelled) {
                    setSelectedContent(null);
                    setErrorMessage('게시글을 불러오지 못했습니다.');
                }
            } finally {
                if (!cancelled) {
                    setIsLoading(false);
                    window.scrollTo(0, 0);
                }
            }
        };

        loadContent();

        return () => {
            cancelled = true;
        };
    }, [unit2Code]);

    if (isLoading) {
        return (
            <div className="MaualEmbedPage">
                <div className="embed-shell embed-status">게시글을 불러오는 중입니다...</div>
            </div>
        );
    }

    if (errorMessage) {
        return (
            <div className="MaualEmbedPage">
                <div className="embed-shell embed-status embed-error">{errorMessage}</div>
            </div>
        );
    }

    return (
        <div className="MaualEmbedPage">
            <div className="embed-shell">
                <MaualContent selectedContent={selectedContent} />
            </div>
        </div>
    );
};

export default MaualEmbedPage;